// extracted by mini-css-extract-plugin
export default {"title":"cba-z","warning":"dba-z","sizeOptionsLegendText":"eba-z"};